import { render, staticRenderFns } from "./BubbleMessage.vue?vue&type=template&id=df2cfdca&scoped=true&"
import script from "./BubbleMessage.vue?vue&type=script&lang=js&"
export * from "./BubbleMessage.vue?vue&type=script&lang=js&"
import style0 from "./BubbleMessage.vue?vue&type=style&index=0&id=df2cfdca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2cfdca",
  null
  
)

export default component.exports